export const DIGITAL_ACCESS_NONE = 'none';
export const DIGITAL_ACCESS_ACTIVE = 'active';
export const DIGITAL_ACCESS_EXPIRED = 'expired';

export const EMPTY_DIGITAL_LISTING_ACCESS = {
  status: DIGITAL_ACCESS_NONE,
  transactionId: null,
  expiredItemIds: [],
  trialEligible: true,
};

export const getDigitalListingCtaMessageId = ({
  isFree,
  status,
  accessMode,
  hasTrial,
  trialEligible = true,
} = {}) => {
  if (status === DIGITAL_ACCESS_ACTIVE) {
    return 'ProductOrderForm.ctaButtonDigitalView';
  }
  const isSubscription = accessMode === 'subscription';
  if (status === DIGITAL_ACCESS_EXPIRED) {
    if (isSubscription) {
      return hasTrial && trialEligible
        ? 'ProductOrderForm.ctaButtonDigitalTryForFree'
        : 'ProductOrderForm.ctaButtonDigitalSubscribe';
    }
    return isFree
      ? 'ProductOrderForm.ctaButtonDigitalRenewFree'
      : 'ProductOrderForm.ctaButtonDigitalRenewPaid';
  }
  if (isSubscription) {
    return hasTrial && trialEligible
      ? 'ProductOrderForm.ctaButtonDigitalTryForFree'
      : 'ProductOrderForm.ctaButtonDigitalSubscribe';
  }
  return isFree ? 'ProductOrderForm.ctaButtonDigitalFree' : 'ProductOrderForm.ctaButtonDigitalPaid';
};

export const isDigitalListingAccessActive = status => status === DIGITAL_ACCESS_ACTIVE;

export const canViewDigitalListingContent = (access, { isOwnListing } = {}) => {
  if (isOwnListing) {
    return false;
  }
  return access?.status === DIGITAL_ACCESS_ACTIVE && !!access?.transactionId;
};

export const isDigitalIncludedItemLocked = ({
  isOwnListing,
  status,
  expiredItemIds,
  itemId,
} = {}) => {
  if (isOwnListing) {
    return false;
  }
  if (status !== DIGITAL_ACCESS_ACTIVE) {
    return true;
  }
  const idStr = itemId == null ? '' : String(itemId?.uuid != null ? itemId.uuid : itemId);
  return (expiredItemIds || []).map(String).includes(idStr);
};
